import AboutUsContainer from "../features/Inicio/About/AboutUsContainer/AboutUsContainer"
import AvalContainer from "../features/Inicio/Aval/AvalContainer/AvalContainer"
import LandingHero from "../features/Inicio/LandingHero/LandingHero";
import './Inicio.css'
import TestimonialGrid from "../features/Inicio/TestimonialSectionFolder/TestimonialGrid/TestimonialGrid";
import NewsCarousel from "../features/Inicio/NewsCarouselFolder/NewsCarousel/NewsCarousel";
import MainLayout from "../layouts/MainLayout/MainLayout";
import PromotionModal from "../components/PromotionModal/PromotionModal";
import { Badge, Button, Checkbox, Stack } from "@mantine/core";
import {IconPhone } from "@tabler/icons-react";
import { Helmet } from 'react-helmet'
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InteractiveMapAndChart from "../features/Inicio/InteractiveMapAndChart/InteractiveMapAndChart";
import ProgramPreview from "../features/Inicio/ProgramPreview/ProgramPreview";
import GranDBanner from "../components/GranDBanner/GranDBanner";

const Inicio = () => {
    // CHeck by date if the promotion modal should be active

    // const handleContactSales = () => {
    //     window.location.href = "https://wa.me/5493518571139/?text=Hola!%20Quiero%20más%20información%20sobre%20la%20promo%20de%20Black%20Friday";
    // };

    // const isPromotionModalActive = new Date() <= new Date("2024-12-01") && new Date() >= new Date("2024-11-20");

    // const handleDownloadPDF = () => {
    //     window.open("https://forvet-main.s3.sa-east-1.amazonaws.com/public/misc/cyber_monday_forvet.pdf", "_blank");
    // };

    const [showCatalogModal, setShowCatalogModal] = useState(false);
    const [saveInLocalStorage, setSaveInLocalStorage] = useState(false);

    useEffect(() => {
        // 3. Verificar localStorage al cargar el componente
        const hasSeenCatalog = localStorage.getItem("FVW-CATALOG-2026");

        if (!hasSeenCatalog) {
            setShowCatalogModal(true);
        }
    }, []);

    const handleCloseCatalogModal = () => {
        if (saveInLocalStorage) {
            localStorage.setItem("FVW-CATALOG-2026", "true");
        }
        setShowCatalogModal(false);
        navigate('/catalogo')
    };

    const navigate = useNavigate()


    return (
        <>
            <Helmet>
                <title>FORVET | Inicio</title>
                <meta name="description"
                    content="Únete a nuestra comunidad de expertos veterinarios que comparten su vasta experiencia para formar especialistas de la más alta calidad en el campo de la medicina veterinaria. En nuestra comunidad de especialistas, el aprendizaje surge de la colaboración entre colegas. Juntos, redefinimos el estándar de la profesión veterinaria. Explora ahora mismo nuestra oferta académica." />
                <meta property="og:title" content="Comunidad de especialistas veterinarios" />
                <meta property="og:description"
                    content="Únete a nuestra comunidad de expertos veterinarios y forma parte de la redefinición del estándar de la profesión veterinaria. Explora nuestra oferta académica." />
                <meta property="og:image" content="%PUBLIC_URL%/mstile-150x150.png" />
                <meta name="twitter:card" content="summary" />
            </Helmet>
            <MainLayout overflow="hidden">
                {/* {isPromotionModalActive &&
                    <PromotionModal
                        title="🎉 Black Friday - Del 20 al 30 de Noviembre 🎉"
                        message={null}
                        courses={[]}
                        image={"https://i.imgur.com/aqnK27X.jpeg"}
                        actions={
                            <>
                                <Button leftIcon={<IconPhone />} onClick={handleContactSales} color="#DF3576">
                                    Consultar a ventas
                                </Button>
                            </>
                        }
                    />
                } */}

                {showCatalogModal && (
                    <PromotionModal

                        title="¡Nuevo catálogo 2026 disponible!"
                        content={<div style={{ textAlign: 'center' }}>
                            <Badge variant="outline" my={6}>ENERO - JUNIO</Badge>
                            <p style={{ fontSize: 'var(--fs-body)' }}>
                                Inicia el año especializándote con los mejores. <br />
                                Encontrá tu próxima capacitación en nuestro catálogo de enero-junio
                            </p>
                            <Button w='max-content' m='auto' my={20} leftIcon={<IconPhone />} onClick={handleCloseCatalogModal} color="#DF3576">
                                Ver catálogo
                            </Button>

                        </div>}
                        onClose={() => {
                            if (saveInLocalStorage) {
                                localStorage.setItem("FVW-CATALOG-2026", "true");
                            }
                            setShowCatalogModal(false)
                        }}
                        courses={[]}
                        actions={
                            <Stack>

                                <Checkbox label='No volver a mostrar' onChange={(event) => {
                                    const value = event.currentTarget.checked
                                    setSaveInLocalStorage(value)
                                }} />
                            </Stack>
                        }
                    />
                )}

                <section className="landing__section" style={{ position: "relative" }}>
                    <LandingHero />
                </section>

                <section className="landing__section--noPadding">
                    <GranDBanner />
                </section>

                <section className="landing__section">
                    <NewsCarousel />
                </section>

                <InteractiveMapAndChart/>                
                {/*   DISABLED SINCE IT IS NOW AVAILABLE ABOVE*/}
                {/*<section className="landing__section">*/}
                {/*   <SpecialtiesCarousel />*/}
                {/*</section>*/}

                {/* <section className="landing__section">
                    < SponsorSection />
                </section> */}

                <section className="landing__section--noPadding">
                    <AboutUsContainer />
                </section>

                {/* <section className="landing__section">
                    <TeamContainer />
                </section> */}

                <section className="landing__section">
                    <ProgramPreview/>
                </section>

                

                 <section className="landing__section--noPadding">
                    <TestimonialGrid />
                </section>

                 <section className="landing__section--noPadding">
                    <AvalContainer />
                </section>
                
                {/* <section className="landing__section">
                    <ContactBanner />
                </section> */}
               
            </MainLayout>
        </>
    )
}
export default Inicio


